<template>
    <div>
        <h3>{{ $l10n.__('Gérer le pied de page des documents') }}</h3>

        <el-radio-group
            :modelValue="modelValue"
            class="flex-column ovy-hidden"
            @change="handleFooterAuto"
        >
            <el-radio :label="true" class="mb-2">
                {{
                    $l10n.__(
                        'Gérer automatiquement le pied de page selon les informations renseignées',
                    )
                }}
            </el-radio>
            <el-radio :label="false">
                {{ $l10n.__('Gérer manuellement le pied de page des documents') }}
            </el-radio>
        </el-radio-group>

        <div v-show="!footerAuto">
            <el-tabs v-if="langs.length > 1" type="border-card" class="mt-3">
                <el-tab-pane v-for="lang of langs" :key="lang.label" :label="lang.label">
                    <template #label>
                        <span class="pt-3 block">
                            <i v-if="lang.flag === 'fa-flag'" :class="lang.flag" class="fa"></i>
                            <img
                                v-else
                                :src="`/ressources/public/img/flags/${
                                    lang.flag ? lang.flag : 'blank'
                                }.png`"
                                :alt="lang.flag"
                            />
                            {{ lang.label }}
                        </span>
                    </template>
                    <RichText
                        v-model="lang.content"
                        :options="optionsRichText"
                        class="custom-richtext"
                    />
                </el-tab-pane>
            </el-tabs>
            <RichText
                v-else
                v-model="langs[0].content"
                :options="optionsRichText"
                class="custom-richtext richtext-alone"
            />
        </div>
    </div>
</template>

<script>
import RichText from 'vcomponents/richtext/RichText.vue';

export default {
    components: {
        RichText,
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        langs: {
            type: Array,
            required: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            optionsRichText: ['Bold', 'CustomTags'],
        };
    },
    computed: {
        footerAuto() {
            return this.modelValue;
        },
    },
    methods: {
        handleFooterAuto(e) {
            this.$emit('update:modelValue', e);
        },
    },
};
</script>

<style lang="scss" scoped>
.rich-text {
    width: 100%;
}
.richtext-alone {
    margin: var(--spacing-3) 0 0;
}
</style>
